import History from '@/pages/History'
import React from 'react'

export default function (props) {
  return (
    <History page='paid' />
  )
}
